(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3282],{

/***/ 83171:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/redwood",
      function () {
        return __webpack_require__(46927);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ RocketIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function RocketIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 18,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 11.25L6.75 9M9 11.25a16.768 16.768 0 003-1.5m-3 1.5V15s2.273-.412 3-1.5c.81-1.215 0-3.75 0-3.75M6.75 9a16.5 16.5 0 011.5-2.962A9.66 9.66 0 0116.5 1.5c0 2.04-.585 5.625-4.5 8.25M6.75 9H3s.413-2.272 1.5-3c1.215-.81 3.75 0 3.75 0m-4.875 6.375c-1.125.945-1.5 3.75-1.5 3.75s2.805-.375 3.75-1.5c.532-.63.525-1.597-.067-2.182a1.635 1.635 0 00-2.183-.068z",
                stroke: "url(#prefix__paint0_linear_476_23236)",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "prefix__paint0_linear_476_23236",
                    x1: 2,
                    y1: 3.5,
                    x2: 14,
                    y2: 16,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#6C47FF"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: 1,
                            stopColor: "#17CCFC"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 91881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ BulletsLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27013);
/* harmony import */ var components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51061);



function BulletsLeft(props) {
    const { image , text , body , icons , background , imageWidth , bulletsProp  } = props;
    const { richText  } = body.filter((text)=>text.key === "bulletsLeftDescription")[0];
    const bullets = bulletsProp ? bulletsProp : [
        {
            id: 1,
            name: text.bulletsLeftFirstHeader,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text.bulletsLeftFirstBody
            }),
            icon: icons[0]
        },
        {
            id: 2,
            name: text.bulletsLeftSecondHeader,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text.bulletsLeftSecondBody
            }),
            icon: icons[1]
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-8 overflow-hidden lg:py-14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-7xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:grid lg:grid-cols-2 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl font-extrabold text-gray-900 sm:text-4xl",
                                children: text.bulletsLeftHeader
                            }),
                            richText.map((text, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-3xl mt-3 text-lg text-gray-500",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_2__/* .SaneBlockChakra */ .C, {
                                        blocks: text
                                    })
                                }, index)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-10 space-y-10",
                                children: bullets.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-clerk-blue",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                            className: "w-6 h-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "ml-16 text-xl font-medium leading-6 text-gray-900",
                                                        children: item.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-2 ml-16 text-lg text-gray-500",
                                                children: item.description
                                            })
                                        ]
                                    }, item.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: background ? "my-5 lg:my-0 bg-white rounded-lg shadow-lg" : "my-5 lg:my-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "m-1 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_1__/* .SaneImage */ .Q, {
                                    src: image.bulletsLeftImage,
                                    width: imageWidth
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 46927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RedwoodPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80943);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68793);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92691);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44320);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58038);
/* harmony import */ var _components_integrations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91881);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41662);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83976);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49596);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78721);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94073);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34507);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51061);






const { redwoodDocs  } = _lib__WEBPACK_IMPORTED_MODULE_1__/* .URLS */ .ns;
const signIn = "import { SignIn } from '@clerk/nextjs';\n  ...\n    return (\n      <>\n        <BackgroundImage />\n        <SignIn />\n      </>\n    );\n  ...";
const userProfile = "import { UserProfile } from '@clerk/nextjs';\n  ...\n    return (\n      <>\n        <CustomHeader />\n        <UserProfile />\n      </>\n    );\n  ...";
var __N_SSG = true;
function RedwoodPage(props) {
    const { image , text , body  } = props;
    const resources = [
        {
            title: "Documentation",
            description: body.find((text)=>text.key === "docsDescription"),
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        },
        {
            title: "Guide",
            description: body.find((text)=>text.key === "blogDescription"),
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
        },
        {
            title: "Demo Repository",
            description: body.find((text)=>text.key === "pluginDescription"),
            icon: _components__WEBPACK_IMPORTED_MODULE_4__/* .RocketIcon */ .W
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h, {
                    title: text.headerTitle,
                    boldTitle: text.headerBoldTitle,
                    subheader: text.headerSubheader
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_6__/* .GetStarted */ .F, {
                doc: redwoodDocs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "mt-12",
                id: "quote",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_7__/* .SmallQuote */ .o, {
                        quote: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Clerk setup and Dashboard DX are SilkySmooth™ and left a great impression. It’s feature-rich and includes MFA, but none of that gets in the way of usability. I have no hesitation recommending developers give it a go — it’s as simple as typing",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                                    children: "redwood setup auth clerk"
                                })
                            ]
                        }),
                        name: text.quoteName,
                        title: text.quoteTitle,
                        image: image.quote
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_integrations__WEBPACK_IMPORTED_MODULE_8__/* .BulletsLeft */ .H, {
                        ...props,
                        imageWidth: 550,
                        icons: [
                            _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                            _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative py-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-base font-semibold tracking-wider uppercase text-clerk-blue",
                                    children: "Resources"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                    children: "Get Started"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mx-auto mt-5 text-xl text-gray-500 max-w-prose",
                                    children: text.resourcesDescription
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
                                        children: resources.map((resource)=>{
                                            const Icon = resource.icon;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pt-6",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flow-root h-full px-6 pb-8 bg-white shadow-xl rounded-2xl",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "-mt-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "inline-flex items-center justify-center p-3 rounded-md shadow-lg bg-clerk-blue",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                                                            className: "w-6 h-6 text-white"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                    className: "mt-8 text-lg font-medium tracking-tight text-gray-900",
                                                                    children: resource.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "mt-5 mb-2 text-base text-left text-gray-500",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_11__/* .SaneBlockChakra */ .C, {
                                                                        blocks: resource.description.richText
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }, resource.title);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_12__/* .Code */ .E, {
                signIn: signIn,
                userProfile: userProfile
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "mt-32 mb-16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_13__/* .Powerful */ .Q, {})
            })
        ]
    });
}


/***/ }),

/***/ 68793:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ClipboardCheckIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ClipboardCheckIcon);

/***/ }),

/***/ 44320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function LightningBoltIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (LightningBoltIcon);

/***/ }),

/***/ 92691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function TemplateIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (TemplateIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4359,9385,1061,7008,9774,2888,179], function() { return __webpack_exec__(83171); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);